module.exports = {
      id: "gztrending-usage",
      viewBox: "0 0 18.806 24.145",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#gztrending",
      toString: function () {
        return this.url;
      }
    }